<template>
    <div class="filter responsive_filter">
        <form action="" class="large_screen">
            <div class="accordion" id="filterAccordion">
                <div class="card">
                    <input type="text" v-model="$store.state.caseTitle_number" class="filter_input"
                        :placeholder='$t("filter.case_title_or_number")'>
                </div>
                <div class="card">
                    <input type="text" v-model="$store.state.accusedName_accusations" class="filter_input"
                        :placeholder='$t("filter.suspect_name")'>
                </div>
                <div class="card">
                    <div id="headingGovernorates">
                        <button class="accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseGovernorates" aria-expanded="false"
                            aria-controls="collapseGovernorates">
                            {{ $t("filter.governorate") }}


                            <span v-if="selectedGovernorates.length > 0" class="badge bg-danger">{{
                                selectedGovernorates.length
                            }}</span>
                        </button>
                    </div>
                    <div id="collapseGovernorates" class="collapse" aria-labelledby="headingGovernorates"
                        data-bs-parent="#filterAccordion1">
                        <div class="card-body">
                            <ul class="countries">
                                <li v-for="governorate in governorates" :key="governorate.id" :id="governorate.id"
                                    class="governorate"
                                    :class="{ 'checked': selectedGovernorates.includes(governorate.id) }"
                                    @click="checkGovernorates(governorate.id)">
                                    <span>{{ governorate.name.ar }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <div id="headingAuthorities">
                        <button class="accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseAuthorities" aria-expanded="false"
                            aria-controls="collapseAuthorities">
                            {{ $t("filter.authority") }}


                            <span v-if="selectedAuthorities.length > 0" class="badge bg-danger">{{
                                selectedAuthorities.length
                            }}</span>
                        </button>
                    </div>
                    <div id="collapseAuthorities" class="collapse" aria-labelledby="headingAuthorities"
                        data-bs-parent="#filterAccordion1">
                        <div class="card-body">
                            <ul class="countries">
                                <li v-for="authority in authorities" :key="authority.id" :id="authority.id"
                                    class="authority" :class="{ 'checked': selectedAuthorities.includes(authority.id) }"
                                    @click="checkAuthoroities(authority.id)">
                                    <span>{{ authority.name }}</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="card">
                    <VueDatePicker v-model="referralYear" ref="datepicker" year-picker auto-apply dark
                        :year-range="[this.currentYear - 10, this.currentYear]"
                        :locale="($i18n.locale == 'ar') ? 'ar' : 'en'" :placeholder="$t('filter.referral_year')"
                        hide-input-icon input-class-name="date-picker" menu-class-name="date-picker-menu"
                        class-name="date-picker-cell" calendar-class-name="date-pocker-calendar" position="left">
                        <span @click="presetDateRange(range)">{{ $t('label') }}</span>
                    </VueDatePicker>
                </div>
            </div>
            <button @click="filter" type="button" class="accordion-btn justify-content-center mt-2">{{
                $t("filter.apply-filter")
                }}</button>
            <button @click="resetFilter" type="button" class="accordion-btn btn-danger justify-content-center mt-2">{{
                $t("filter.reset")
                }}</button>
        </form>

        <!-- responsive -->
        <form action="" class="small_screen">
            <div class="accordion accordion_small" id="small_filterAccordion">
                <div class="card">
                    <div id="headingGender_small">
                        <button class="accordion-btn" type="button" data-bs-toggle="collapse"
                            data-bs-target="#collapseGender_small" aria-expanded="true"
                            aria-controls="collapseGender_small">
                            {{ $t("filter.filter") }}
                        </button>
                    </div>
                    <div id="collapseGender_small" class="collapse" aria-labelledby="headingGender_small"
                        data-bs-parent="#small_filterAccordion">
                        <div class="card-body">
                            <div class="accordion" id="filterAccordion1">
                                <div class="card">
                                    <input type="text" v-model="$store.state.caseTitle_number" class="filter_input"
                                        :placeholder='$t("filter.case_title_or_number")'>
                                </div>
                                <div class="card">
                                    <input type="text" v-model="$store.state.accusedName_accusations"
                                        class="filter_input" :placeholder='$t("filter.suspect_name")'>
                                </div>
                                <div class="card">
                                    <div id="headingGovernorates">
                                        <button class="accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseGovernorates" aria-expanded="false"
                                            aria-controls="collapseGovernorates">
                                            {{ $t("filter.governorate") }}


                                            <span v-if="selectedGovernorates.length > 0" class="badge bg-danger">{{
                                                selectedGovernorates.length
                                            }}</span>
                                        </button>
                                    </div>
                                    <div id="collapseGovernorates" class="collapse"
                                        aria-labelledby="headingGovernorates" data-bs-parent="#filterAccordion1">
                                        <div class="card-body">
                                            <ul class="countries">
                                                <li v-for="governorate in governorates" :key="governorate.id"
                                                    :id="governorate.id" class="governorate"
                                                    :class="{ 'checked': selectedGovernorates.includes(governorate.id) }"
                                                    @click="checkGovernorates(governorate.id)">
                                                    <span>{{ governorate.name.ar }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <div id="headingAuthorities">
                                        <button class="accordion-btn collapsed" type="button" data-bs-toggle="collapse"
                                            data-bs-target="#collapseAuthorities" aria-expanded="false"
                                            aria-controls="collapseAuthorities">
                                            {{ $t("filter.authority") }}


                                            <span v-if="selectedAuthorities.length > 0" class="badge bg-danger">{{
                                                selectedAuthorities.length
                                            }}</span>
                                        </button>
                                    </div>
                                    <div id="collapseAuthorities" class="collapse" aria-labelledby="headingAuthorities"
                                        data-bs-parent="#filterAccordion1">
                                        <div class="card-body">
                                            <ul class="countries">
                                                <li v-for="authority in authorities" :key="authority.id"
                                                    :id="authority.id" class="authority"
                                                    :class="{ 'checked': selectedAuthorities.includes(authority.id) }"
                                                    @click="checkAuthoroities(authority.id)">
                                                    <span>{{ authority.name }}</span>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="card">
                                    <VueDatePicker v-model="referralYear" ref="datepicker" year-picker auto-apply dark
                                        :year-range="[this.currentYear - 10, this.currentYear]"
                                        :locale="($i18n.locale == 'ar') ? 'ar' : 'en'"
                                        :placeholder="$t('filter.referral_year')" hide-input-icon
                                        input-class-name="date-picker" menu-class-name="date-picker-menu"
                                        class-name="date-picker-cell" calendar-class-name="date-pocker-calendar"
                                        position="left">
                                        <span @click="presetDateRange(range)">{{ $t('label') }}</span>
                                    </VueDatePicker>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <button @click="filter" type="button" class="accordion-btn btn_small justify-content-center mt-2">{{
                $t("filter.apply")
            }}</button>
            <button @click="resetFilter" type="button" class="accordion-btn btn-danger justify-content-center mt-2">{{
                $t("filter.reset")
            }}</button>
        </form>

    </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import VueDatePicker from '@vuepic/vue-datepicker';
import Slider from '@vueform/slider';
import { endOfMonth, endOfYear, startOfMonth, startOfYear, endOfWeek, startOfWeek, subMonths } from 'date-fns';
import '@vuepic/vue-datepicker/dist/main.css';
import { mapState } from 'vuex';

const base_url = process.env.VUE_APP_BASE_URL;

export default {
    name: "Filter",
    components: {
        VueDatePicker,
        onMounted,
        Slider,
    },
    setup() {
        // Date picker
        const referralDate = ref();
        const firstSessionDate = ref();
        const referralYear = ref();
        const presetRanges = ref([
            { label: 'Today', range: [new Date(), new Date()] },
            { label: 'This Week', range: [startOfWeek(new Date()), endOfWeek(new Date())] },
            { label: 'This Month', range: [startOfMonth(new Date()), endOfMonth(new Date())] },
            { label: 'Last Month', range: [startOfMonth(subMonths(new Date(), 1)), endOfMonth(subMonths(new Date(), 1))], },
            { label: 'This Year', range: [startOfYear(new Date()), endOfYear(new Date())] },
        ]);

        return { referralDate, firstSessionDate, referralYear, presetRanges }
    },
    data() {
        return {
            governorates: [],
            authorities: [],
            currentYear: new Date().getFullYear(),
            rtl: localStorage.getItem('lang') == 'ar'
        }
    },
    computed: {
        ...mapState([
            "selectedGovernorates",
            "selectedAuthorities"
        ])
    },
    methods: {

        filterCheck(array, value) {
            if (array.includes(value)) {
                array = array.filter(function (filtered) {
                    return filtered !== value;
                });
            } else {
                array.push(value);
            };
            return array
        },

        checkGovernorates(governorateID) {
            this.$store.state.selectedGovernorates = this.filterCheck(this.$store.state.selectedGovernorates, governorateID);
        },
        checkAuthoroities(authorityID) {
            this.$store.state.selectedAuthorities = this.filterCheck(this.$store.state.selectedAuthorities, authorityID);
        },

        // Fetching data from API
        async fetchGovernorates() {
            try {
                const res = await fetch(base_url + '/get_governorates')
                const governorates = await res.json()
                console.log(governorates.data);

                return governorates.data
            } catch (error) {
                console.log(error);
            }
        },
        async fetchAuthorities() {
            try {
                const res = await fetch(base_url + '/get_referral_authorities')
                const authorities = await res.json()
                return authorities;
            } catch (error) {
                console.log(error);

            }
        },

        // Send data to Parent
        filter(openPanel = true) {
            this.$store.state.referralDate = this.referralDate;
            this.$store.state.firstSessionDate = this.firstSessionDate;
            this.$store.state.referralYear = this.referralYear;
            this.$emit('filtered', openPanel)
        },

        resetFilter() {
            this.$store.state.caseTitle_number = "";
            this.$store.state.accusedName_accusations = "";
            this.$store.state.selectedGovernorates = [];
            this.$store.state.selectedAuthorities = [];
            this.referralYear = "";
            this.filter(false);
        }
    },
    async created() {
        this.governorates = await this.fetchGovernorates();
        this.authorities = await this.fetchAuthorities()
    }
}

</script>

<style src="@vueform/slider/themes/default.css"></style>
<style scoped>
.filter {
    position: absolute;
    bottom: 20px;
    left: 20px;
    width: 0px;
    transition: 0.3s;
    width: 260px;
    max-height: 100%;
    z-index: 10;
}

.filter * {
    white-space: nowrap;
}

.filter .card-body {
    padding: 0;
}

.filter .card-body.slider-body {
    padding: 1.5rem;
}

.filter ul {
    list-style: none;
    padding: 0;
    margin: 0;
    background-color: #23282b10;
    max-height: 200px;
    overflow-x: visible;
    overflow-y: auto;
}

.filter ul li {
    /* text-align: left; */
    border-bottom: 1px solid #ffffff0a;
    cursor: pointer;
}

.filter ul li span {
    display: block;
    padding: .75rem 1.5rem;
    transition: 0.3s;
    color: white;
}

.filter ul li.checked span {
    padding: .75rem 2rem;
    opacity: 1;
    color: #FFB22C;
}

.filter .accordion {
    border-radius: 0;
    box-shadow: 0 0 20px 0 #222;

}

.filter .accordion .card {
    border: none;
    border-radius: 0;
    background-color: #23282b;
    box-shadow: none;
    padding: 0;
}

.filter .accordion .card+.card>* {
    border-top: 1px solid #212629 !important;
}

.filter .accordion-btn,
.filter .accordion .card input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1.5rem;
    color: var(--lightGrey);
    background-color: #292e30 !important;
    color: white !important;
    border-radius: 0;
    width: 100%;
    border: none;
}

.filter .accordion .card input::placeholder {
    color: rgba(255, 255, 255, 0.6);
}

.filter .accordion .card input:focus {
    outline: none;
}

.filter .accordion-btn.btn-danger {
    background-color: #b41412 !important;
    flex: 100% 0 0;
}

/*  responsive */
.small_screen {
    display: none;
}

@media(max-width:768px) {
    .filter {
        width: calc(100% - 80px);
    }

    .small_screen {
        display: flex;
        align-items: end;
        flex-wrap: wrap;
    }

    .small_screen .btn_small {
        max-width: 25%;
        min-width: 105px;
        background-color: #000 !important;
    }

    .small_screen .accordion_small {
        flex: 1;
        width: 75%;
    }

    .large_screen {
        display: none !important;
    }

    /* Filter styles for cases page */
    .filter-wrapper .filter {
        width: 100%;
    }

    .filter-wrapper .large_screen {
        display: block !important;
    }

    .filter-wrapper .small_screen {
        display: none !important;
    }
}
</style>